import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, onyx, onyxLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    padding: indent * 0.8,
    paddingRight: indent * 3,
    overflow: 'visible' as const,
  },
  text: {
    color: onyxLight,
  },
  columns: {
    flexDirection: 'row' as const,
    minWidth: 0,
    maxWidth: '100%' as const,
    width: '100%' as const,
    overflow: 'visible' as const,
  },
  textColumn: {
    flex: 1,
    minWidth: 0,
    paddingRight: indent / 2,
  },
  rankIconColumn: {
    flex: 0,
    flexShrink: 0,
    paddingLeft: 0,
    marginLeft: 0,
    marginRight: indent * 1.5,
    shadowColor: onyx,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  progressDescription: {
    color: black,
    ...getFontFamily('bold'),
  },
  showDetail: {
    flexDirection: 'row' as const,
    marginTop: 8,
    minWidth: 0,
    flex: 1,
    alignItems: 'center' as const,
  },
  showDetailArrow: {
    color: onyxLight,
    fontSize: 18,
    marginLeft: 6,
    flexShrink: 0,
  },
});
